import gql from 'graphql-tag';

export const SET_BOOKING_STATUS = gql`
  mutation updateListOrder($input: UpdateListOrderInput!) {
    updateListOrder(input: $input) {
      order {
        id
        stage
        commissionTriggerPoint
      }
    }
  }
`;
